import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';
import { useAuth } from '../../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Active / Inactive switch for an investor or a client (user 2026-10-19).
 * Inactive = left the book: kept in all history, left out of every list for
 * something new. The server refuses to make an investor inactive while they
 * hold loans, cash or a Deal Room holding, and a client while any loan has a
 * positive balance — the reason is shown. Investors' login is separate.
 * Backend: routers/portfolio_status.py.
 */
export default function ActiveSwitch({ kind, id, active, label, onChanged, testId }) {
  const [busy, setBusy] = useState(false);
  const { token } = useAuth();
  const url = kind === 'client'
    ? `${API_URL}/api/admin/clients/${encodeURIComponent(id)}/active-status`
    : `${API_URL}/api/admin/investors/${encodeURIComponent(id)}/portfolio-status`;

  const toggle = async (next) => {
    if (!next && !window.confirm(
      `Make ${label || id} inactive?\n\nThey stay in all history (ledgers, statements, reports) but won't be offered for anything new.`
      + (kind === 'investor' ? ' Their portal login is not affected.' : ''))) return;
    setBusy(true);
    try {
      await axios.post(url, { active: next }, { headers: { Authorization: `Bearer ${token}` } });
      toast.success(`${label || id} is now ${next ? 'active' : 'inactive'}`);
      if (onChanged) onChanged(next);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not change the status', { duration: 9000 });
    } finally {
      setBusy(false);
    }
  };

  return (
    <label className="inline-flex items-center gap-2 text-xs cursor-pointer" data-testid={testId}>
      <Switch checked={active !== false} disabled={busy} onCheckedChange={toggle} />
      <span className={active !== false ? 'text-green-700' : 'text-gray-500'}>{active !== false ? 'Active' : 'Inactive'}</span>
    </label>
  );
}
